import api from './apiClient'

/**
 * `GET /dashboard/summary?subCompanyId&from&to` — indicadores do Épico 01.
 *
 * Indicadores sem lastro no dado legado vêm `null`, com o motivo em
 * `unavailable[]` (`{ indicator, reason }`). A tela mostra "—" nesses casos:
 * número inventado é pior que ausência de número.
 *
 * O período é opcional e vai como `from`/`to` em `YYYY-MM-DD` — a API fecha o
 * `to` no fim do dia e devolve em `period` o recorte que de fato aplicou.
 * Campo vazio sai como `undefined` e some da URL: o zod da API recusa string
 * vazia com 400.
 */
export const getDashboardSummary = async (subCompanyId, filtros = {}) =>
  api.get('/dashboard/summary', {
    params: {
      subCompanyId,
      from: filtros.startDate || undefined,
      to: filtros.finishDate || undefined,
    },
  })
